module.exports = __webpack_public_path__ + "img/100.b812fb94.jpg";